module.exports = __webpack_public_path__ + "490514de876cffa913120fe36ccfaf67.svg";